<template>
    <div>
        <div v-if="!disabled">
            <h5 style="padding: 20px">
                Please customize your file format: <br />
                Note: First and second column can not contain empty records. If
                you have already set the configuration once or chosen the
                default configuration, you will not be able to change it.
            </h5>
        </div>
        <div v-else>
            <h5 style="padding: 20px">
                Upload a file with the following column configurations. <br />
                Note: All columns are required but the data in the column
                labelled with * is required. The rest are optional.
            </h5>
        </div>
        <div class="col-md-12 row-min-space">
            <div class="scrollable more-fields-popup">
                <div class="row">
                    <div class="col-md-6">
                        <label class="m-b-15" for="labels">LABEL</label>
                    </div>
                    <div class="col-md-6">
                        <label class="m-b-15" for="type">TYPE</label>
                    </div>
                </div>
                <div v-for="(item, index) in labels" :key="index" class="row">
                    <div class="col-md-6">
                        <b-form-group class="m-b-15">
                            <b-form-input
                                id="field-label"
                                v-model="item.label"
                                v-validate="'required|min:1'"
                                type="text"
                                placeholder="Enter column label"
                                autocomplete="no"
                                data-vv-name="label"
                                :class="{
                                    'is-invalid': errors.has('label'),
                                }"
                                :disabled="disabled"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-5">
                        <b-form-group class="m-b-15">
                            <b-form-select
                                id="field-type"
                                v-model="item.type"
                                v-validate="{
                                    required: true,
                                }"
                                data-vv-name="type"
                                :options="options"
                                :class="{
                                    'is-invalid': errors.has('type'),
                                }"
                                :disabled="disabled"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-xs-12 col-md-12" v-if="labels.length > 2">
                        <span
                            class="removed-row-class"
                            style="right: 8px"
                            @click.prevent="deleteRow(index)"
                            ><i class="icon-delete"></i
                        ></span>
                    </div> -->
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12 add-more-section">
                    <b-form-group>
                        <button
                            class="btn btn-transparent btn-block"
                            @click.prevent="addOption()"
                        >
                            <span class="btn-text">+ Add More</span>
                        </button>
                    </b-form-group>
                </div>
            </div> -->
        </div>
        <div v-if="!disabled" class="col-md-12 action-buttons">
            <b-button
                type="button"
                variant="primary"
                :class="loading ? 'disabled' : ''"
                @click="onClick"
            >
                <span class="btn-text">Submit</span>
                <span class="loader"></span>
            </b-button>
            <b-button
                type="reset"
                variant="link"
                :class="loading ? 'disabled' : ''"
                @click="onCancel"
            >
                <span class="btn-text">Cancel</span>
                <span class="loader"></span>
            </b-button>
        </div>
        <div v-else class="col-md-12 action-buttons">
            <b-button
                type="button"
                variant="primary"
                :class="loading ? 'disabled' : ''"
                @click="onClose"
            >
                <span class="btn-text">Close</span>
                <span class="loader"></span>
            </b-button>
        </div>

        <base-toast></base-toast>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
const apiUrl_data = process.env.VUE_APP_API_URL
const headers = {
    Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
}
import Radio from '@/components/registration/Radio.vue'
export default {
    components: {
        Radio,
    },
    computed: {
        ...mapGetters(['loading', 'scopes', 'showPageLoader', 'dataSegmentId']),
    }, // End of Component > computed

    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('showPageLoader', true)
                this.importCustomData()
            }
        },
    },

    mounted() {
        this.importCustomData()
        this.checkConfig()
        if (!this.checkPermission(['manage-configure-client-list'])) {
            this.disabled = true
        }
    },
    data() {
        return {
            disabled: false,
            labels: [
                { label: 'Customer ID*', type: 'String' },
                { label: 'Full Name*', type: 'String' },
                { label: 'Middle Name', type: 'String' },
                { label: 'Fathers Name', type: 'String' },
                { label: 'Date Of Birth', type: 'Date' },
                { label: 'Nationality*', type: 'String' },
                { label: 'Gender', type: 'String' },
                { label: 'Country Of Residence', type: 'String' },
                { label: 'ID Type', type: 'String' },
                { label: 'ID Number', type: 'String' },
                { label: 'Source List*', type: 'String' },
                { label: 'List Category*', type: 'String' },
                { label: 'List Type', type: 'String' },
                { label: 'Source Reference ID', type: 'String' },
                { label: 'Title', type: 'String' },
                { label: 'Biography', type: 'String' },
                { label: 'Address', type: 'String' },
                { label: 'Place of Birth', type: 'String' },
                { label: 'Category', type: 'String' },
                { label: 'Added On*', type: 'Date' },
                { label: 'Updated On', type: 'Date' },
                { label: 'Status*', type: 'Number' },
            ],
            options: [
                { value: null, text: 'Select Column Type' },
                { value: 'String', text: 'String' },
                { value: 'Number', text: 'Integer' },
                { value: 'Date', text: 'Date' },
                { value: 'Boolean', text: 'Boolean' },
            ],
        }
    },
    methods: {
        // async addOption() {
        //     const result = await this.$validator.validateAll()
        //     if (result) {
        //         this.labels.push({ label: '', type: '' })
        //     } else {
        //         this.$store.commit(
        //             'setError',
        //             this.errors.all()[0].replace(/[0-9]/g, '')
        //         )
        //     }
        // },
        // deleteRow(index) {
        //     this.labels.splice(index, 1)
        // },
        onClick() {
            // //console.log("options: ", this.labels)
            this.$emit('response', this.labels)
        },
        onCancel() {
            this.$emit('response', this.labels)
        },
        onClose() {
            this.$emit('response', this.labels)
        },
        checkPermission(scopes) {
            return !!_.intersection(scopes, this.scopes).length
        },
        async importCustomData() {
            // //console.log("custom data api")
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                try {
                    let response = await axios.get(
                        apiUrl_data +
                            'screening-data/import-custom-data/' +
                            dataSegmentId,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    if (response) {
                        this.disabled = true
                    }
                } catch (e) {
                    //console.log(e)
                }
            }

            this.$store.commit('showPageLoader', false)
        },

        async checkConfig() {
            let dataSegmentId = this.dataSegmentId
            try {
                let response = await axios.get(
                    apiUrl_data +
                        'screening-data/column-config/' +
                        dataSegmentId,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${localStorage.getItem(
                                'vueauth_token'
                            )}`,
                        },
                    }
                )
                if (response) {
                    this.labels = response.data.data
                }
            } catch (e) {
                //console.log(e)
            }
        },
    },
}
</script>
